module.exports = __webpack_public_path__ + "static/media/esign.9ddbdedd.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/esign.gif
// module id = 2215
// module chunks = 17